<template>
  <div class="welcome">
    <v-layout column>
      <v-flex xs12>
        <div class="hidden-md-and-up" style="overflow: hidden;">
          <v-row align="center" justify="center">
            <v-card elevation="0">
              <v-row justify="center">
                <div style="overflow: hidden; height: 100svh">
                  <v-img dark height="" style="height: 100svh" src="img/sample_banner.jpg">
                  </v-img>
                </div>
                <v-overlay :absolute="absolute" :value="overlay" :opacity="opacity" style="z-index: 2">
                  <a @click="goToHome()">
                    <v-img max-width="200" max-height="54" contain class="mt-2  mb-3 hidden-sm-and-down"
                      src="img/aatf_logo.png">
                    </v-img>
                  </a>
                  <a @click="goToHome()">
                    <v-img max-width="180" max-height="100" style="margin: 0 auto;" class="mt-2 mb-3 hidden-md-and-up"
                      src="img/aatf_logo.png">
                    </v-img>
                  </a>
                  <div class="display-1 font-weight-black ml-1" style="text-align: center;">{{ $t("slogan") }}</div>
                  <div class="ml-7 pt-8 mr-7 d-flex align-center justify-center"
                    style=" font-size: clamp(1.125rem, 1.0243rem + 0.5034vw, 1.4963rem); text-align: center;">

                    {{ $t("discoverMessage") }}

                  </div>
                  <div class="ml-7 mr-7 pt-8 d-flex align-center justify-center"
                    style=" font-size: clamp(1.125rem, 1.0243rem + 0.5034vw, 1.4963rem);">

                    <v-btn class="ma-2" rounded color="secondary" router to="/search">
                      {{ $t("searchButton") }}
                    </v-btn>
                  </div>
                  <div style="margin-top: -30px; margin-left: -25px;">
                  </div>
                  <div align="right" style="margin-top: -16px; margin-right: -30px;">
                  </div>
                </v-overlay>
              </v-row>
            </v-card>
          </v-row>
        </div>
        <div class="hidden-sm-and-down" style="margin-top: 40px">
          <v-row align="center" justify="center">
            <v-card elevation="0">
              <v-row justify="center">
                <v-img dark height="50vh" src="img/sb.jpg">
                </v-img>
                <v-overlay :absolute="absolute" :value="overlay" :opacity="opacity" style="z-index: 1;">

                  <div class=" ml-7 mr-7 d-flex align-center justify-center"
                    style="font-size: clamp(1.2rem, 0.8rem + 2.5vw, 3rem); text-align: center">

                    {{ $t("slogan") }}

                  </div>
                  <div class="ml-7 mr-7 d-flex align-center justify-center"
                    style=" font-size: clamp(1.125rem, 1.0243rem + 0.5034vw, 1.4963rem);">
                    {{ $t("discoverMessage") }}

                  </div>
                  <div class="ml-7 mr-7 pt-8 d-flex align-center justify-center"
                    style=" font-size: clamp(1.125rem, 1.0243rem + 0.5034vw, 1.4963rem);">

                    <v-btn class="ma-2" rounded color="secondary" router to="/search">
                      {{ $t("searchButton") }}
                    </v-btn>

                  </div>
                  <div style="margin-top: -50px">
                  </div>
                  <div align="right" style="margin-top: -16px">

                  </div>
                </v-overlay>
              </v-row>
            </v-card>
          </v-row>
        </div>
      </v-flex>
      <v-flex xs12 class="white">
        <v-container class="my-10 mb-15">
          <v-layout column class="my-8">
            <v-flex xs12 class="my-5">
              <div class="headingFontSize grey--text" align="center"
                >
                {{ $t("welcomeMessage") }}
              </div>
              <div align="center" class="mt-10">
                {{ $t("welcomeDetailsMsg") }}
              </div>
            </v-flex>
          </v-layout>
          <div>
            <div class="w-100 d-flex justify-center">
              <v-row class="d-flex align-center justify-center" style="max-width: min(90%, 800px);">
                <div class="search"
                    style="border-radius: 20px; border: 1px solid #507536; padding: .5em .9em; width: 100%">
                  <input class="input input-width" type="text" :placeholder="$t('searchHereMessage')" @keydown.enter="goToUser"
                        v-model="searchText"
                        style="border-radius: 20px; width:90%; border-right: none; outline: none; padding: .3em .001em;">
                  <!-- <router-link > -->
                    <v-icon large color="green darken-2" @click="goToUser">mdi-magnify</v-icon>
                  <!-- </router-link> -->
                </div>
              </v-row>
            </div>
          </div>
        </v-container>
      </v-flex>
      <!-- <v-flex xs12 class="background">
        <v-container class="my-16">
          <div align="center" class="headingFontSize primary--text font weight-black mt-16 mb-5">
            {{ $t("whatYouGetMessage") }}
          </div>
          <div class="mt-8">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs5></v-flex>
                <v-flex xs2>
                  <v-divider class="primary mx-10"></v-divider>
                  <v-divider class="primary"></v-divider>
                  <v-divider class="primary mx-10"></v-divider>
                </v-flex>
                <v-flex xs5></v-flex>
              </v-layout>
            </v-flex>
          </div>
          <div class="mt-10 mb-16">
            <v-layout row wrap class="mb-16">
              <v-flex xs12 md4>
                <v-card elevation="0" class="primary mx-2 my-1" shaped height="550">
                  <v-card-text>
                    <v-layout column class="my-10">
                      <v-flex xs12>
                        <div align="center">
                          <v-icon size="150px" class="white--text">
                            mdi-human-male-board-poll
                          </v-icon>
                        </div>
                      </v-flex>
                      <v-flex xs12>
                        <div align="center" class="white--text mt-5 miniHeadingsFont"
                          style="font-family: 'SC Prosper Sans Regular';">
                          {{ $t("productDevelopment") }}
                        </div>
                      </v-flex>
                      <v-flex xs12>
                        <div align="center" class="white--text mt-5">
                          {{ $t("productDevelopmentMessage") }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card elevation="0" class="secondary mx-2 my-1" shaped height="550">
                  <v-card-text>
                    <v-layout column class="my-10">
                      <v-flex xs12>
                        <div align="center">
                          <v-icon size="150px" class="white--text">
                            mdi-account-child
                          </v-icon>
                        </div>
                      </v-flex>
                      <v-flex xs12>
                        <div align="center" class="white--text mt-5 miniHeadingsFont"
                          style="font-family: 'SC Prosper Sans Regular';">
                          {{ $t("enablingEnvironment") }}
                        </div>
                      </v-flex>
                      <v-flex xs12>
                        <div align="center" class="white--text mt-5">
                          {{ $t("enablingEnvironmentMessage") }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card elevation="0" class="primary mx-2 my-1" shaped height="550">
                  <v-card-text>
                    <v-layout column class="my-10">
                      <v-flex xs12>
                        <div align="center">
                          <v-icon size="150px" class="white--text">
                            mdi-cash-100
                          </v-icon>
                        </div>
                      </v-flex>
                      <v-flex xs12>
                        <div align="center" class="white--text mt-5 miniHeadingsFont"
                          style="font-family: 'SC Prosper Sans Regular';">
                          {{ $t("investment") }}
                        </div>
                      </v-flex>
                      <v-flex xs12>
                        <div align="center" class="white--text mt-5">
                          {{ $t("investmentMessage") }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
          <div align="center" class="my-10">
            <v-btn outlined class="text-none secondary--text" rounded router to="/about">
              {{ $t("viewMoreMessage") }}
              <v-icon right>mdi-information-variant</v-icon>
            </v-btn>
          </div>
        </v-container>
      </v-flex> -->
      <v-flex xs12 style="background-color: rgba(80, 117, 54, 0.06);">
        <v-container>
          <div align="center" class="headingFontSize mt-6 mb-5" style="color: #507536;">
            {{ $t("recommendedResearch") }}
          </div>
          <div class="mt-8">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs5></v-flex>
                <v-flex xs2>
                  <v-divider class="primary mx-10"></v-divider>
                  <v-divider class="primary"></v-divider>
                  <v-divider class="primary mx-10"></v-divider>
                </v-flex>
                <v-flex xs5></v-flex>
              </v-layout>
            </v-flex>
          </div>
          <div align="center" class="mt-8 pb-0 font-weight-black justify-center d-flex align-center" style="color: #507536;">
            <p>{{ $t("recommendedResearchMessage") }}</p>
          </div>

          <v-carousel height="625" hide-delimiter-background show-arrows-on-hover>
            <v-carousel-item v-for="(row, index) in recommendedResearch" :key="index">
              <div class="mx-2 my-5">
                <v-layout row wrap>
                  <v-flex class="d-flex justify-center" xs12 md3 v-for="(item, idx) in recommendedResearch[index]" :key="idx" style="padding-inline: .5em;">
                    <v-card :loading="loading" class="mx-auto my-12" width="600px" height="500px">
                      <template slot="progress">
                        <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
                      </template>
												<v-img v-if="item.thumbnail_link != null && item.thumbnail_link != ''" :src="item.thumbnail_link" height="250"/> 
												<v-icon v-else size="250" color="#DCDCDC">mdi-file-document</v-icon>

                      <v-card-title>{{ formatTitle(item.title) }}</v-card-title>

                      <v-card-text style="height: 130px;">
                        <div style="height: 90px;">{{ formatText(item.description)}}</div>
                        <div class="mt-3"><v-chip x-small color="secondary" class="white--text mr-1" v-for="(tm, index) in getTagArray(item.tags)" :key="index">{{ tm }}</v-chip></div>
                      </v-card-text>

                      <v-divider class="mx-4"></v-divider>
                      <v-card-actions>
                        <v-btn color="" text @click="navigateToViewMore(item)">
                          {{ $t("readMessage") }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </div>
            </v-carousel-item>
          </v-carousel>

          <div align="center" class="mb-5">
            <v-btn style="background-color: #507536;" rounded class=" white--text">
              {{ $t("viewMoreMessage") }}
              <v-icon right dark>
                mdi-page-next
              </v-icon>
            </v-btn>
          </div>
        </v-container>
      </v-flex>
      <!-- <v-flex xs12 class="white">
        <v-container class="my-10">
          <v-layout column class="my-8">
            <v-flex xs12 class="my-16">
              <div class="headingFontSize grey--text" align="center" style=" max-width: min(90%, 700px); margin: 0 auto;">
                Can't Find What You Are Looking For?
              </div>
              <div align="center" class="mt-8" style=" max-width: min(90%, 700px); margin: 0 auto">
                Tips on how to search more effectively
              </div>
            </v-flex>
          </v-layout>
          <div class="w-100 d-flex justify-center">
            <v-row class="d-flex align-center justify-center" style="max-width: min(90%, 500px);">
              <div align="center" class="">
                <v-btn style="background-color: #507536;" rounded class=" white--text">
                  See tips
                  <v-icon right dark>
                    mdi-lightbulb-on-outline
                  </v-icon>
                </v-btn>
              </div>
            </v-row>
          </div>
        </v-container>
        <v-container>
        </v-container>
      </v-flex> -->
      <v-flex xs12 class="">
        <v-container>
          <div align="center" class="headingFontSize mt-6 mb-5" style="color: #507536;">
            {{ $t("latestResearch") }}
          </div>
          <div class="mt-8">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs5></v-flex>
                <v-flex xs2>
                  <v-divider class="primary mx-10"></v-divider>
                  <v-divider class="primary"></v-divider>
                  <v-divider class="primary mx-10"></v-divider>
                </v-flex>
                <v-flex xs5></v-flex>
              </v-layout>
            </v-flex>
          </div>
          <div align="center" class="mt-8 pb-0 white--text font-weight-black justify-center d-flex align-center">
            <p style="color: #507536;"> {{ $t("latestResearchMessage") }}</p>
          </div>

          <v-carousel height="625" hide-delimiter-background show-arrows-on-hover>
            <v-carousel-item v-for="(row, index) in latestResearch" :key="index">
              <div class="mx-2 my-5">
                <v-layout row wrap>
                  <v-flex class="d-flex justify-center" xs12 md3 v-for="item in latestResearch[index]" :key="index" style="padding-inline: .5em;">
                    <v-card :loading="loading" class="mx-auto my-12" width="600px" height="500px">
                      <template slot="progress">
                        <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
                      </template>
												<v-img v-if="item.thumbnail_link != null && item.thumbnail_link != ''" :src="item.thumbnail_link" height="250"/> 
												<v-icon v-else size="250" color="#DCDCDC">mdi-file-document</v-icon>

                      <v-card-title>{{ formatTitle(item.title) }}</v-card-title>

                      <v-card-text style="height: 130px;">
                        <div style="height: 90px;">{{ formatText(item.description)}}</div>
                        <div class="mt-3"><v-chip x-small color="secondary" class="white--text mr-1" v-for="(tm, index) in getTagArray(item.tags)" :key="index">{{ tm }}</v-chip></div>
                      </v-card-text>

                      <v-divider class="mx-4"></v-divider>
                      <v-card-actions>
                        <v-btn text @click="navigateToViewMore(item)">
                          {{ $t("readMessage") }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </div>
            </v-carousel-item>
          </v-carousel>
          <v-dialog v-model="showPopup" max-width="1000">
                  <v-dialog v-model="showPopup" max-width="1000" persistent>
                    <v-card>
                      <div class="d-flex justify-end">
                        <v-btn class="ma-2" outlined fab color="primary" @click="showPopup = false">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </div>
                      <v-card-text class="pt-1">
                        <viewMoreLayout v-if="showPopup" :title="popupData.title" :description="popupData.description"
                          :imageSrc="popupData.imageSrc" :programme="popupData.programme" :project="popupData.project" :uuid="popupData.uuid" :type="popupData.type"
                          :country="popupData.country" :tags="popupData.tags" :abstract="popupData.abstract"  @close="closePopup" />
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="showPopup = false">{{ $t("closeMessage") }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-dialog>
          <div align="center" class="my-5">
            <v-btn style="background-color: #507536;" rounded class=" white--text">
              {{ $t("viewMoreMessage") }}
              <v-icon right dark>
                mdi-page-next
              </v-icon>
            </v-btn>
          </div>
        </v-container>
      </v-flex>
      <v-flex xs12 style="background-color: rgba(80, 117, 54, 0.06);">
        <div class="partners" style="padding-block: 2.5em;">
          <v-container>
            <div align="center" class=" primary--text font weight-black headingFontSize">
              {{ $t("whoWeWorkWith") }}
            </div>
            <div class="mb-8 mt-8">
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs5></v-flex>
                  <v-flex xs2>
                    <v-divider class="primary mx-10"></v-divider>
                    <v-divider class="primary"></v-divider>
                    <v-divider class="primary mx-10"></v-divider>
                  </v-flex>
                  <v-flex xs5></v-flex>
                </v-layout>
              </v-flex>
            </div>
            <v-row justify="space-around">
              <v-col class="partnerDiv">
                <v-card height="200" width="200"><v-img class="mx-1" src="img/AFDB.png"></v-img></v-card>
                <v-card height="200" width="200"><v-img class="mx-1" src="img/GATES.png"></v-img></v-card>
                <v-card height="200" width="200"><v-img class="mx-1" src="img/GIZ.png"></v-img></v-card>
                <v-card height="200" width="200"><v-img class="mx-1" src="img/HBF.png"></v-img></v-card>
                <v-card height="200" width="200"><v-img class="mx-1" src="img/PEPSICO.png"></v-img></v-card>
                <v-card height="200" width="200"><v-img class="mx-1" src="img/ROCKERFELLER.png"></v-img></v-card>
                <v-card height="200" width="200"><v-img class="mx-1" src="img/USAID.png"></v-img></v-card>
                <v-card height="200" width="200"><v-img class="mx-1" src="img/UKAID.png"></v-img></v-card>
                <v-card height="200" width="200"><v-img class="mx-1" src="img/SYGENTA.png"></v-img></v-card>
                <v-card height="200" width="200"><v-img class="mx-1" src="img/SNV.png"></v-img></v-card>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<style>
.partnerDiv {
  background-color: #50753611;
  border-radius: 10px;
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, 1fr)
}

.partnerImageRadius {
  border-radius: 10px;
}

/*option 1:this makes the video responsive*/
.videoDiv {
  width: 70%;
  /*or whatever % you prefer*/
  margin: 0 auto;
  display: block;
}

/* option 2* does not make the video responsive*/

.videoDiv {
  margin: 0 auto;
  display: block;
}

.headingFontSize {
  font-size: clamp(1.4238rem, 1.0921rem + 1.6585vw, 2.6469rem) !important;
  /* font-size: clamp(1.2rem, 0.8rem + 2.5vw, 3rem) !important; */
  font-family: 'SC Prosper Sans Regular' !important;
}

.miniHeadingsFont {
  font-size: clamp(1.125rem, 1.0243rem + 0.5034vw, 1.4963rem);
  font-family: 'SC Prosper Sans Regular' !important;
  text-transform: capitalize !important;
}

* {
  font-family: 'SC Prosper Sans Regular';

}

@media (max-width:500px) {
  .input-width {
    width: 80% !important
  }
}

@media (min-width:500px) {
  .partnerDiv {
    grid-template-columns: repeat(5, 1fr);
    padding: 1em;
  }
}
</style>
<script>
import apiCall from "@/utils/api";
import { mapState, mapGetters, mapActions } from "vuex";
import Vue from "vue";
import VClamp from "vue-clamp";
import SearchArea from "@/components/search/Base/SearchArea.vue";
import viewMoreLayout from "./viewMoreLayout.vue";

export default {
  props:{
    searchTerm:String,
    type:String,
    title:String,
    uuid:String

  },
  components: {
    VClamp,
    SearchArea,
    viewMoreLayout
  },
  data() {
    return {
      path: process.env.VUE_APP_API_URL,
      color: "",
      message: "",
      snackbar: false,
      drawer: false,

      absolute: true,
      overlay: true,
      opacity: 0.1,

      loading: false,
      openArticle: false,
      searchText:"",
      latestResearch: {},
      recommendedResearch: {},
      showPopup: false,
      popupData: {},
    };
  },
  watch: {
    publicNewsFeeds() {
      this.chunkPublicNewsFeeds();
    },
  },
  mounted() {
    window.onscroll = () => {
      this.changeColor();
    };
    window.addEventListener("keydown", this.handleEscape);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleEscape);
  },
  created() {
    window.scrollTo(0, 0);
    this.changeHeaderColor("transparent");
    this.changeTitleColor("red--text");
    this.changeButtonColor("red--text hidden-sm-and-down text-none caption");

    this.getLatestResearch();
    this.getRecommendedResearch();

  },
  methods: {
    goToUser(){
      this.$router.push({ name: 'search', query: { searchTerm: this.searchText } });
      console.log(this.$route.query.searchTerm)
    },
    ...mapActions([
      "changeHeaderColor",
      "changeTitleColor",
      "changeButtonColor",
    ]),
    getLatestResearch(){
      apiCall({
        url: "/api/search-submission?search-type=publicationSearch&search-term=&submission-type=&option=latest",
        method: "GET",
      })
        .then((resp) => {
          this.latestResearch = this.chunkSearchData(resp.data);
          console.log(this.latestResearch.title)
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getRecommendedResearch(){
      apiCall({
        url: "/api/search-submission?search-type=publicationSearch&search-term=&submission-type=&option=recommended",
        method: "GET",
      })
        .then((resp) => {
          this.recommendedResearch = this.chunkSearchData(Object.values(resp));
          console.log(this.recommendedResearch)
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closePopup() {
      this.showPopup = false;
    },
    handleEscape(event) {
      if (event.key === "Escape") {
        this.closePopup();
      }
    },
    navigateToViewMore(item) {
      this.popupData = {
        title: item.title,
        description: item.description,
        imageSrc: item.src || this.getFallbackImage(),
        programme: item.collection?.community?.name || "NA",
        project: item.collection?.name || "N/A",
        country: item.country?.name || "N/A",
        abstract: item.recent_abstract || "N/A",
        uuid:item.bitstream_uuid,
        type:item.file_type,
        tags: (() => {
          try {
            return JSON.parse(item.tags);
          } catch {
            return [];
          }
        })(),

      };
      apiCall({
        url: "/api/addview",
        method: "POST",
        data:{
          uuid:item.bitstream_uuid
        }
      })
      .then((resp) => {
          this.latestResearch = this.chunkSearchData(resp.data);
          console.log(this.latestResearch.title)
        })
        .catch((error) => {
          console.log(error);
        });
      this.showPopup = true;
    },
    getFallbackImage() {
      const fallbackImages = {
        Dataset: "data:image/png;base64,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",
        Video: "https://cdn.dribbble.com/users/17914/screenshots/4902225/media/0d6d47739dae97adc81ca7076ee56cc9.png",
        Image: "https://assets.gopromotional.co.uk/images/article-placeholder.jpg",
        Article: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRMbgPNOtKRmcAvBfHasZ9F7G3oNWbYIY1cdA&s",
        MusicalScore: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfMSWeotwB1QyiECMiv75JqPTVaz5ErrOokA&s"
      };
      return fallbackImages[this.type] || "https://www.aatf-africa.org/wp-content/uploads/2024/01/AATF-Website-Home-Page-Design-December-2023-WELCOME-TO-AATF.png";
    },

    chunkSearchData(input, chunkSize = 5 ) {
      var originalArray =[];

			for (var i = 0; i < input.length; i++) {
				originalArray.push(input[i])
			}

      const chunks = [];
      for (let i = 0; i < originalArray.length; i += chunkSize) {
        chunks.push(originalArray.slice(i, i + chunkSize));
      }
      return chunks;
		},
    formatTitle(text) {
      return text.length > 15 ? text.substring(0, 15) + "..." : text;
    },
    formatText(text) {
      return text.length > 100 ? text.substring(0, 100) + "..." : text;
    },
    getTagArray(tags) {
      var resp = JSON.parse(tags);
      if(resp.length > 3){
        resp = resp.slice(0, 3);
      }
      return resp;
    },

    changeColor() {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        this.changeHeaderColor("white");
        this.changeTitleColor("black--text");
        this.changeButtonColor("black--text hidden-sm-and-down text-none caption");
      } else {
        this.changeHeaderColor("transparent");
        this.changeTitleColor("white--text");
        this.changeButtonColor("white--text hidden-sm-and-down text-none caption");
      }
    },
  },
  computed: {
    ...mapGetters(["darkState"]),
  },
};
</script>